import config from '../../config'
import fetcher from '../fetcher'
import type { CvFeedback, GptConversationFeedback, InterviewFeedback } from './types'

const BASE_URL = `${config.VITE_ZRIVE_API_URL}/api/gpt`

export const addCVFeedback = async (_: string, { arg }: { arg: CvFeedback }): Promise<CvFeedback> => {
  const res = await fetcher(`${BASE_URL}/cv-roaster/${arg.cvId}/feedback`, {
    method: 'POST',
    body: JSON.stringify(arg)
  })
  return res.data
}

export const addConversationFeedback = async (_: string, { arg }: { arg: GptConversationFeedback }): Promise<GptConversationFeedback> => {
  const res = await fetcher(`${BASE_URL}/conversations/${arg.conversationId}/feedback`, {
    method: 'POST',
    body: JSON.stringify(arg)
  })
  return res.data
}

export const addInterviewFeedback = async (_: string, { arg }: { arg: InterviewFeedback }): Promise<InterviewFeedback> => {
  const res = await fetcher(`${BASE_URL}/interview/${arg.interviewId}/feedback`, {
    method: 'POST',
    body: JSON.stringify(arg)
  })
  return res.data
}
